import script from "./MarkerProvenanceDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./MarkerProvenanceDialog.vue?vue&type=script&setup=true&lang=js"

import "./MarkerProvenanceDialog.vue?vue&type=style&index=0&id=3199208e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3199208e"]])

export default __exports__